import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { PageStateService } from '@shared/service/page-state.service';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnChanges {
  @Input() dataSize = 0;
  @Input() pageSize = 0;
  @Input() maxPage = 5;
  @Input() changeRange = 2;
  @Output() changePageEvent = new EventEmitter<number>();
  private pageStateService = inject(PageStateService);
  protected pageList: number[] = [];
  protected currentPage = 1;
  protected currentList: number[] = [];
  protected currentListIndex = 0;
  protected lastPage = 0;
  protected firstPage = 0;
  protected totalPage = 0;

  constructor() {
    this.currentPage = this.pageStateService.page;
  }

  ngOnChanges(): void {
    this.getPageList();
    // 最少必須顯示五頁
    if (this.maxPage < 5) {
      this.maxPage = 5;
    }
  }

  protected changePage(page: number) {
    this.currentPage = page;
    this.pageStateService.page = this.currentPage;
    this.getCurrentList();
    this.changePageEvent.emit(this.currentPage);
  }

  private getPageList() {
    this.pageList = [];
    this.totalPage = Math.ceil(this.dataSize / this.pageSize);
    for (let page = 1; page <= this.totalPage; page++) {
      this.pageList.push(page);
    }
    this.getCurrentList();
  }

  private getCurrentList() {
    if (this.pageList.length <= this.maxPage) {
      this.currentList = this.pageList;
    } else {
      // 是否選擇會向前列表的頁碼
      const isChoosePrevPage =
        this.currentList.indexOf(this.currentPage) >
        this.maxPage - (this.changeRange + 1);
      // 是否選擇會向後列表的頁碼
      const isChooseNextPage =
        this.currentList.indexOf(this.currentPage) < this.changeRange;
      // 是否回到第一列表
      const isfirstList = this.currentPage <= this.changeRange + 1;
      // 是否回到最後列表
      const islastList = this.currentPage >= this.totalPage - this.changeRange;
      switch (true) {
        case isfirstList:
          this.currentList = this.pageList.slice(0, this.maxPage);
          // console.log('回到第一列表');
          break;
        case islastList:
          this.currentList = this.pageList.slice(
            this.pageList[this.pageList.length - 1 - this.maxPage],
            this.pageList[this.pageList.length - 1]
          );
          // console.log('回到最後列表');
          break;
        case isChoosePrevPage || isChooseNextPage:
          this.currentList = this.currentList = this.pageList.slice(
            this.currentPage - this.maxPage / 2,
            this.currentPage + this.maxPage / 2
          );
          // console.log('往後換頁');
          break;
      }
    }
  }
}
